import { useAuthStore } from '@/modules/auth/store/auth';
import { storeToRefs } from 'pinia';

/**
 * Blocks a pending-approval merchant from actions that would 403 on the API:
 * product create/edit and Stripe Connect payout setup.
 */
export default defineNuxtRouteMiddleware(() => {
  const { isPendingApproval } = storeToRefs(useAuthStore());

  if (isPendingApproval.value) {
    return navigateTo('/merchant/listing');
  }
});
